import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import NewFacilitieRequest from "./newFacilitieRequest ";
import FacilitiesInProgress from "./facilitiesInProgress";

export default function FacilitiesConfigPage() {
  return (
    <Switch>
      {
        <Redirect
          exact={true}
          from="/facilities"
          to="/facilities/NewFacilitieRequest"
        />
      }
      <ContentRoute
        path="/facilities/NewFacilitieRequest"
        component={NewFacilitieRequest}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/facilities/FacilitiesInProgress"
        component={FacilitiesInProgress}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
